/**
 * Created by prakash on 22/9/18.
 */

/**
 * An object used to get page information from the server
 */
export class ApplicationListPage {
    //The number of elements in the page
    size: number = 0;

    //The total number of elements
    totalElements: number = 0;

    //The total number of pages
    totalPages: number = 0;

    //The current page number
    pageNumber: number = 0;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/applicationManagement/applicationList-datatable/applicationList-page.ts